export function resizeImageToBase64(image, width, height, format = 'image/jpeg', quality = 0.6) {
   var canvas = document.createElement('canvas')
   Object.assign(canvas, { width, height })
   canvas.getContext('2d').drawImage(image, 0, 0, width, height)
   return canvas.toDataURL(format, quality)
}
export function blobImageToBase64(blob, size = 800, format = 'image/jpeg', quality = 0.6) {
   const widthOrHeight = (width, height) => {
      const max = { width, height }
      if (width > height) {
         if (width > size) {
            max.height *= size / width
            max.width = size
         }
      } else {
         if (height > size) {
            max.width *= size / height
            max.height = size
         }
      }
      return { width: Math.floor(max.width), height: Math.floor(max.height) }
   }
   const promise = new Promise(function (resolve) {
      var reader = new FileReader()
      reader.onload = () => {
         var image = new Image()
         image.onload = () => {
            const max = widthOrHeight(image.width, image.height)
            var base64 = resizeImageToBase64(image, max.width, max.height, format, quality)
            resolve(base64)
         }
         image.src = reader.result
      }
      reader.readAsDataURL(blob)
   })
   return promise
}

export function flatten(obj) {
   var toReturn = {}
   for (var key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
      if (['Face', 'View', 'Logo', 'Card', 'Sign', 'File', 'Code', 'Form', 'Head', 'Hero', 'Audio', 'Video'].includes(key)) {
         toReturn[key] = obj[key].length ? obj[key][0] : ''
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
         if (!Array.isArray(obj[key]) && /^[A-Z]/.test(key)) {
            toReturn[key] = obj[key]
         } else {
            var flatObject = flatten(obj[key])
            for (var ndx in flatObject) {
               if (!Object.prototype.hasOwnProperty.call(flatObject, ndx)) continue
               toReturn[ndx] = flatObject[ndx]
            }
         }
      } else toReturn[key] = obj[key]
   }
   return toReturn
}

export function cleanUp(obj) {
   Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object') {
         const child = cleanUp(obj[key])
         child === undefined && delete obj[key]
      } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
         delete obj[key]
      }
   })
   return Object.keys(obj).length > 0 || obj instanceof Array ? obj : undefined
}

export function pastel(count) {
   const clrs = []
   while (clrs.length < count) {
      const R = Math.floor((Math.random() * 127) + 127)
      const G = Math.floor((Math.random() * 127) + 127)
      const B = Math.floor((Math.random() * 127) + 127)
      const rgb = (R << 16) + (G << 8) + B
      const clr = `#${rgb.toString(16)}`
      clrs.indexOf(clr) < 0 && clrs.push(clr)
   }
   return count === 1 ? clrs[0] : clrs
}
export function luminance(color) {
   if (!color) return false
   const rgb = parseInt(color.slice(1), 16)
   const r = (rgb >> 16) & 0xff
   const g = (rgb >> 8) & 0xff
   const b = (rgb >> 0) & 0xff
   const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709
   // return luma > 155 // tooBright()
   return luma
}

export function unique(value, index, self) {
   return self.indexOf(value) === index
}
export function distinct(value, index, self) {
   return self.findIndex(j => j.identity === value.identity) === index
}
export function imageFromUrl(image) {
   return image.length === 21 ? `/images/${image.substr(0, 11).replace(/\./g, '/')}${image.slice(-10)}` : image
}
export function encrypt(str) {
   return Buffer.from(str.replace(/\+/g, '-').replace(/\//g, '_')).toString('base64').replace(/=+$/m, '')
}
export function decrypt(str) {
   return Buffer.from(str.padEnd(str.length + (4 - str.length % 4) % 4, '='), 'base64').toString()
}
export function jsonify(json) { return JSON.parse(JSON.stringify(json)) }